module.exports = __webpack_public_path__ + "./assets/fonts/Gilroy-MediumItalic.ttf?3e34575c41985a25eb6096f88ce4fee4";